const zh = {
  nav: { about: "关于我们", services: "服务", logistics: "物流", clients: "客户", news: "新闻", contact: "联系我们", cta: "预约咨询", menu: "菜单", close: "关闭" },
  global: {
    eyebrow: "世界在流动",
    title: "从海岸到_世界大都会_。",
    intro: "洽谈生意的人们、运输中的货物：这就是我们每天工作的世界。",
    capitals: "世界大都会",
    deals: "人与生意",
    base: "我的基地：海岸",
    ops: "运输中的货物",
    timezones: "时区",
    newsTicker: "全球新闻 · 实时更新 · 请在下方“新闻与市场”栏目阅读",
  },
  news: {
    eyebrow: "06 — 新闻与市场",
    title: "运输世界，_实时更新_。",
    intro: "新闻自动同步自国际物流行业的主要门户。",
    read: "阅读",
    updated: "已更新",
  },
  hero: {
    eyebrow: "企业咨询 · 进出口 · 物流",
    lines: ["我们带领企业", "跨越", "_全球_边界。"],
    sub: "我们陪伴企业完成进出口、单证流程、进入新市场和国际物流：从第一次沟通到最终交付。",
    cta: "聊聊您的项目",
    cta2: "了解服务",
    scroll: "滚动",
    tags: ["海运", "空运", "陆运", "快递"],
    frame: "全球航线，单一对接人",
  },
  marquee: ["进口 · 出口", "单证流程", "温控运输", "危险品 DGR", "海运", "空运", "公路运输", "仓储与包装", "市场开发"],
  about: {
    eyebrow: "01 — 关于我们",
    title: "一位顾问，一张网络，_一套方法_，助您走向海外。",
    body1: "MF Logistics Consulting Group 的诞生，是为了在企业决定跨境销售、采购或生产时，提供一个独一无二的靠山。",
    body2: "我们将单证专业能力、市场认知与物流实操结合，把扩张的构想变成实实在在的货物、合同与人脉。",
    founderRole: "创始人兼首席执行官",
    founderLine: "多年深耕欧洲与国际市场的经验：以用心和方法，陪伴企业跨越边界。",
    doorCaption: "我的大门永远为您敞开",
    pillars: [
      { t: "全局视野", d: "商业策略、单证与运输，作为一个整体项目统筹。" },
      { t: "实地执行", d: "每一票货、每一份文件，我们都跟进到底。" },
      { t: "人脉网络", d: "在目标市场精选合作伙伴、供应商与买家。" },
    ],
  },
  services: {
    eyebrow: "02 — 服务",
    title: "量身定制的咨询，_从单证_到集装箱。",
    intro: "每家企业都不同：我们为您设计最适合的路径。",
    items: [
      { t: "进出口", d: "规划货流、贸易术语（Incoterms）、供应商与物流合作伙伴，让海外买卖更安心。" },
      { t: "单证流程", d: "清关、原产地证书、运输单据与合规事务，精准办理。" },
      { t: "产品市场导入", d: "目标市场分析、准入要求与产品上市策略。" },
      { t: "海外市场开拓", d: "国际化规划与在新国家、新渠道的商业增长。" },
      { t: "人脉开拓", d: "在目标市场搜寻并甄选买家、经销商与合作伙伴。" },
      { t: "海外订单开发", d: "寻找国际客户并处理其订单请求，从首次接触到订单确认。" },
      { t: "企业咨询", d: "在组织、流程及企业经营的其他需求上提供支持。" },
    ],
  },
  logistics: {
    eyebrow: "03 — 物流",
    title: "任何货物，_任何_路线。",
    intro: "我们为各类货物和运输方式安排门到门运输，含仓储与包装。",
    modesTitle: "运输方式",
    modesDesc: "我们组合海运、空运、公路与快递，在时效、成本与安全之间找到最佳平衡。",
    modes: ["海运", "空运", "公路", "快递"],
    goodsTitle: "货物类型",
    goods: [
      { t: "常温 — 一般货物", d: "一般货物、零担与整车。" },
      { t: "温控货物", d: "冷链与专属温区。" },
      { t: "危险品 DGR", d: "ADR / IMDG / IATA 危险品的单证与操作管理。" },
    ],
    subsLabel: "货物细分",
    subs: ["食品及易腐品（含冷冻）", "医药产品", "机械设备", "奢侈品", "服装", "化妆品", "…等更多"],
    insurance: { t: "货物保险", d: "您的货物在每段运输中都有全额保障。" },
    docsPermits: { t: "单证与许可", d: "注册、卫生证书、入境许可及每一项手续。" },
    palletControl: { t: "托盘化与查验", d: "仓储、托盘化和仓库内的货物查验。" },
    warehousing: { t: "仓储", d: "入库、库存管理与配送。" },
    packaging: { t: "包装", d: "符合货物、运输方式与法规的包装。" },
    customs: { t: "单证与清关", d: "从提单到证书：每一份文件都井井有条。" },
  },
  newsletter: {
    eyebrow: "订阅资讯",
    titleAccent: "随时了解全球动态",
    title: "。",
    sub: "每月精选：航线、市场与跨境贸易的实用建议。绝无垃圾邮件。",
    placeholder: "您的邮箱",
    cta: "订阅",
    sending: "发送中…",
    ok: "订阅成功！您将收到我们的最新资讯。",
    already: "您已经订阅过了。",
    error: "出现问题，请重试。",
    privacy: "订阅即表示您同意接收我们的资讯。绝无垃圾邮件：可随时取消。",
  },
  clients: {
    eyebrow: "04 — 客户",
    title: "选择_我们的服务_的企业。",
    intro: "部分我们在国际市场上陪伴过的企业。",
    consTitle: "通过_咨询服务_。",
    impTitle: "通过_进出口_。",
    placeholder: "[客户标志]",
    visit: "访问",
  },
  contact: {
    eyebrow: "05 — 联系我们",
    title: "告诉我们，_您想去哪里_。",
    intro: "给我们留言：我们会尽快回复，共同规划最佳路径。",
    fields: { name: "姓名", company: "公司", email: "电子邮箱", phone: "电话", service: "您需要什么？", message: "留言" },
    servicePick: "选择一项服务",
    logisticsOption: "运输与物流",
    submit: "发送请求",
    sending: "发送中…",
    success: "谢谢！我们已收到您的请求，会尽快与您联系。",
    error: "发送失败。请检查所填内容后重试。",
    direct: "直接联系",
    emailLabel: "邮箱",
    phoneLabel: "电话",
    vatLabel: "增值税号",
    addressLabel: "办公地点",
  },
  footer: { tagline: "企业咨询、进出口与国际物流。", rights: "版权所有。", admin: "管理后台", top: "回到顶部" },
};
export default zh;
